angular.module('property')
    .controller('PropertyNotesController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, Property) {
        this.$onInit = () => {
            this.item = data;
            this.form = {
                id: this.item.id,
                notes: this.item.notes,
                action: 'notes'
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return Property.action(this.form).$promise.then(result => {
                $rootScope.$broadcast('property.updated', result);
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        };
    })
